import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';

type PropsType = {
  onClickMenuDelete: () => void;
  onClickMenuExport?: () => void;
};

export const useDropdownMenu = ({ onClickMenuDelete, onClickMenuExport }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.project' });

  return (
    <Menu
      onClick={({ domEvent }) => domEvent.stopPropagation()}
      items={[
        {
          key: '1',
          onClick: onClickMenuExport,
          label: t('export'),
        },
        {
          key: '2',
          danger: true,
          onClick: onClickMenuDelete,
          label: t('delete'),
        },
      ]}
    />
  );
};
